import axios from 'axios'

import { FileToDownload } from './types'

export async function downloadFileRequest({
  signedUrl,
  mimeType,
  onProgress,
  abortController
}: FileToDownload) {
  const response = await axios.get(signedUrl, {
    responseType: 'blob',
    signal: abortController?.signal,
    onDownloadProgress: ({ loaded, total }) =>
      total && onProgress?.(Math.round((loaded * 100) / total)),
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    }
  })

  return new Blob([response.data], { type: mimeType })
}
